import * as PARS from '../../core';

export interface ReportState {
  isLoadingReport: boolean;
  isLoadingReports: boolean;
  report?: any;
  reports: IReport[];
}

export interface IReport {
  description?: string;
  group?: ReportGroups;
  link?: string;
  name: string;
  parameterAssignment: string;
  reportId: string;
  showDateParameters?: boolean;
  workspaceId: string;
}

export enum ReportGroups {
  Activity = 'Activity',
  Learner = 'Learner',
  None = 'None',
  Program = 'Program',
}

export const GET_REPORT = 'GET_REPORT';
export const GET_REPORT_SUCCESS = 'GET_REPORT_SUCCESS';
export const GET_REPORT_FAILURE = 'GET_REPORT_FAILURE';
export const GET_REPORTS = 'GET_REPORTS';
export const GET_REPORTS_FAILURE = 'GET_REPORTS_FAILURE';
export const GET_REPORTS_SUCCESS = 'GET_REPORTS_SUCCESS';

export interface GetReport extends PARS.Models.PARSAction<undefined, typeof GET_REPORT> {
  type: typeof GET_REPORT;
}

export interface GetReportSuccess extends PARS.Models.PARSAction<any, typeof GET_REPORT_SUCCESS> {
  type: typeof GET_REPORT_SUCCESS;
  payload: any; // TODO add type
}

export interface GetReportFailure extends PARS.Models.PARSAction<undefined, typeof GET_REPORT_FAILURE> {
  type: typeof GET_REPORT_FAILURE;
}

export interface GetReports extends PARS.Models.PARSAction<undefined, typeof GET_REPORTS> {
  type: typeof GET_REPORTS;
}

export interface GetReportsFailure extends PARS.Models.PARSAction<undefined, typeof GET_REPORTS_FAILURE> {
  type: typeof GET_REPORTS_FAILURE;
}

export interface GetReportsSuccess extends PARS.Models.PARSAction<any, typeof GET_REPORTS_SUCCESS> {
  type: typeof GET_REPORTS_SUCCESS;
  payload: any; // TODO add type
}

export type ReportActionTypes =
  | GetReport
  | GetReportFailure
  | GetReportSuccess
  | GetReports
  | GetReportsFailure
  | GetReportsSuccess;
